import propTypes from 'prop-types';
import React from 'react';
import Modal from '../../common/Modal';
import Icon, { GLYPHS } from '../../common/icon';
import QueueItem from './QueueItem';
import DateFilter from '../../common/DatePickerV2';

const Queue = ({
  label,
  btnLabel,
  btnClass,
  queueModalIsOn,
  open,
  close,
  add,
  timezone,
  pendingJobs,
  finishedJobs,
  showFinished,
  setShowFinished,
  refresh,
  filterDates,
  defaultEmail,
  dateToString,
  canEditDateRange,
  isFixedRange,
  fixedRangeDays,
  endingDateMax,
  onFilterDatesChange,
}) => (
  <div className="u-inline-block u-mh-">
    <button className={btnClass} type="button" onClick={open}>
      {btnLabel}
      {pendingJobs.length ? ` (${pendingJobs.length})` : ''}
    </button>
    <Modal
      title={label}
      display-if={queueModalIsOn}
      close={close}
      showCloseButton
      className="c-modal_overflowable"
      bodyClassName="c-modal__body_overflowable"
    >
      <div className="u-ph u-pv">
        <div className="u-flex u-mb+">
          <div className="u-width-120">
            <button
              type="button"
              className="c-btn c-btn--small"
              onClick={() => setShowFinished(!showFinished)}
              display-if={finishedJobs.length}
            >
              {showFinished ? 'Hide' : 'Show'} finished ({finishedJobs.length})
            </button>
          </div>
          <div className="u-flex-1 u-text-center u-fontsize-small">
            <p className="dark-mode-white" display-if={filterDates.startDate && filterDates.endDate}>
              Exporting for date range:
            </p>
            <p
              className="dark-mode-white"
              display-if={!canEditDateRange && filterDates.startDate && filterDates.endDate}
            >
              {dateToString(filterDates.startDate)} - {dateToString(filterDates.endDate)}
            </p>
            <div className="u-mt- u-mb u-ph+" display-if={canEditDateRange}>
              <DateFilter
                range
                isFixedRange={isFixedRange}
                fixedRangeDays={fixedRangeDays}
                presets={!isFixedRange}
                endDate={endingDateMax}
                onChange={onFilterDatesChange}
                from={filterDates.startDate}
                to={filterDates.endDate}
              />
            </div>
          </div>
          <div className="u-width-120 u-text-right u-cursor-pointer">
            <Icon
              glyph={GLYPHS.refresh}
              size="medium"
              onClick={refresh}
              className="u-float-right"
              title="Refresh"
            />
          </div>
        </div>

        <form onSubmit={add} className="layout u-mt">
          <div className="layout__item u-5/6">
            <input type="email" name="email" defaultValue={defaultEmail} className="c-input c-input--white" />
          </div>
          <div className="layout__item u-1/6">
            <button type="submit" className="c-btn c-btn--medium u-height-40 u-block u-ph">Export</button>
          </div>
        </form>

        <div className="c-queue-modal__jobs">
          {pendingJobs.map(job =>
            <QueueItem
              key={job.id}
              startDate={job.data.startDate}
              endDate={job.data.endDate}
              email={job.data.email}
              createdAt={job.createdAt}
              finishedAt={job.createdAt}
              status={job.status}
              timezone={timezone}
            />
          )}
          <p
            display-if={!pendingJobs.length}
            className="u-mt u-mb- u-text-center dark-mode-white"
          >
            No pending jobs.
          </p>

          <div display-if={showFinished}>
            {finishedJobs.map(job =>
              <QueueItem
                key={job.id}
                email={job.data.email}
                startDate={job.data.startDate}
                endDate={job.data.endDate}
                createdAt={job.createdAt}
                finishedAt={job.finishedAt}
                status={job.status}
                timezone={timezone}
              />
            )}
          </div>
        </div>
      </div>
    </Modal>
  </div>
);

Queue.propTypes = {
  btnLabel: propTypes.string,
  filterDates: propTypes.object, // eslint-disable-line
  btnClass: propTypes.string,
  label: propTypes.string.isRequired,
  queueModalIsOn: propTypes.bool,
  open: propTypes.func.isRequired,
  close: propTypes.func.isRequired,
  add: propTypes.func.isRequired,
  refresh: propTypes.func.isRequired,
  pendingJobs: propTypes.array, // eslint-disable-line
  finishedJobs: propTypes.array, // eslint-disable-line
  showFinished: propTypes.bool.isRequired,
  setShowFinished: propTypes.func.isRequired,
  defaultEmail: propTypes.string,
  timezone: propTypes.string.isRequired,
  dateToString: propTypes.func.isRequired,
  canEditDateRange: propTypes.bool,
  isFixedRange: propTypes.bool,
  fixedRangeDays: propTypes.number,
  endingDateMax: propTypes.object, // eslint-disable-line
  onFilterDatesChange: propTypes.func.isRequired,
};

Queue.defaultProps = {
  btnLabel: 'Download full list',
  btnClass: 'c-btn c-btn--medium',
  filters: {},
  isOn: false,
  pendingJobs: [],
  finishedJobs: [],
  defaultEmail: '',
  queueModalIsOn: false,
  canEditDateRange: false,
  isFixedRange: false,
  fixedRangeDays: 1,
};

export default Queue;
